import { RopeDirection } from 'models/RopeDirection';

export class RopeDirectionTranslationValueConverter {
  toView(value) {
    return 'general.' + RopeDirection[value].toLowerCase();
  }
}
